import ColorSelect from "components/ReactHookForm/ColorSelect/ColorSelect"
import SwitchField from "components/ReactHookForm/SwitchField"
import FileUpload from "components/ReactHookForm/FileUpload"
import React, { useMemo } from "react"
import { Email } from "sharedTypes"
import { useController } from "react-hook-form"
import SidePanelHeader from "./components/SidePanelHeader"
import EditorSection from "./components/EditorSection"
import SidePanelBlockAttributes from "./components/SidePanelBlockAttributes"

type Props = {
  email: Email
  onChange: (email: Email) => void
  onCancel: () => void
}

const SettingsPanel = ({
  email,
  onChange,
  onCancel,
}: Props) => {
  const {
    backgroundColor,
    borderColor,
    emailAttachment: { fileName },
    showUnsubscribe,
    showEmailAttachment,
  } = email
  const initialValues = useMemo(() => ({
    backgroundColor: backgroundColor || "#FFFFFF",
    borderColor: borderColor || "#CCCCCC",
    showEmailAttachment: showEmailAttachment ?? !!fileName,
    showUnsubscribe,
  }), [backgroundColor, borderColor, fileName, showUnsubscribe, showEmailAttachment])

  return (
    <SidePanelBlockAttributes
      onChange={onChange}
      onCancel={onCancel}
      initialValues={initialValues}
      selectedBlockId={email.id}
    >
      {({ control }) => (
        <>
          <SidePanelHeader>Email Settings</SidePanelHeader>
          <EditorSection>
            <ColorSelect label="Bg Color" name="backgroundColor" control={control} colorScheme="light" />
          </EditorSection>
          <EditorSection>
            <ColorSelect label="Border Color" name="borderColor" control={control} />
          </EditorSection>
          <AttachmentSection fileName={fileName} control={control} />
          <EditorSection>
            <SwitchField label="Unsubscribe Link" name="showUnsubscribe" control={control} />
          </EditorSection>
        </>
      )}
    </SidePanelBlockAttributes>
  )
}

const AttachmentSection = ({ fileName, control }) => {
  const { field: { value: showEmailAttachment } } = useController({ name: "showEmailAttachment", control })

  return (
    <EditorSection>
      <SwitchField label="Email Attachment" name="showEmailAttachment" control={control} dataTestId="email-attachment-switch" />
      {showEmailAttachment && <FileUpload name="emailAttachment" fileName={fileName} control={control} />}
    </EditorSection>
  )
}

export default SettingsPanel
